import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountingMigrationRow, formatMigrationStartDate } from "../utils";

export const StartDateCell = memo(function StartDateCell({
    row,
}: CellContext<ViewTableFeatures, AccountingMigrationRow, unknown>) {
    return (
        <ViewTableCell>
            {formatMigrationStartDate(
                row.original.accountingMigration.startDate,
            )}
        </ViewTableCell>
    );
});
